var _g, _g2, _g3, _g4, _g5, _g6, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsSoccer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.6834 15.8167L18.3334 11.1667V8.83333L16.0834 7.25C13.0501 8.2 10.4668 10.2 8.78345 12.8167L9.43345 15.05L11.6834 15.8167Z",
    fill: "url(#paint0_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.35008 18.2L6.68342 19.4166C6.68342 19.6166 6.66675 19.8 6.66675 20C6.66675 23.3166 7.88341 26.35 9.90008 28.6833L11.8001 28.5166L13.1167 26.2333L10.6667 19L8.35008 18.2Z",
    fill: "url(#paint1_linear)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.5667 15.05L31.2167 12.8167C29.5334 10.2 26.9667 8.2 23.9167 7.25L21.6667 8.83333V11.1667L28.3167 15.8167L30.5667 15.05Z",
    fill: "url(#paint2_linear)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.9501 18.3L16.2167 25H23.7834L26.0501 18.3L20.0001 14.0667L13.9501 18.3Z",
    fill: "url(#paint3_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.7501 28.3333L14.6835 30.1833L15.8335 32.6666C17.1501 33.0833 18.5501 33.3333 20.0001 33.3333C21.4501 33.3333 22.8501 33.0833 24.1668 32.6499L25.3168 30.1666L24.2501 28.3333H15.7501Z",
    fill: "url(#paint4_linear)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.3 19.4166L31.6334 18.2L29.3334 19L26.9 26.2333L28.2167 28.5166L30.1167 28.6833C32.1167 26.35 33.3334 23.3166 33.3334 20C33.3334 19.8 33.3167 19.6166 33.3 19.4166Z",
    fill: "url(#paint5_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33325C10.8 3.33325 3.33337 10.7999 3.33337 19.9999C3.33337 29.1999 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.1999 36.6667 19.9999C36.6667 10.7999 29.2 3.33325 20 3.33325ZM21.6667 8.83325L23.9167 7.24992C26.95 8.18325 29.5334 10.1833 31.2167 12.8166L30.5667 15.0499L28.3167 15.8166L21.6667 11.1666V8.83325ZM16.0834 7.24992L18.3334 8.83325V11.1666L11.6834 15.8166L9.43337 15.0499L8.78337 12.8166C10.4667 10.1999 13.05 8.19992 16.0834 7.24992ZM11.8 28.5166L9.90004 28.6833C7.88337 26.3499 6.66671 23.3166 6.66671 19.9999C6.66671 19.7999 6.68337 19.6166 6.70004 19.4166L8.36671 18.1999L10.6667 18.9999L13.1 26.2333L11.8 28.5166ZM24.1667 32.6499C22.85 33.0833 21.45 33.3333 20 33.3333C18.55 33.3333 17.15 33.0833 15.8334 32.6499L14.6834 30.1666L15.75 28.3333H24.2667L25.3334 30.1833L24.1667 32.6499ZM23.7834 24.9999H16.2167L13.9667 18.2999L20 14.0666L26.05 18.2999L23.7834 24.9999ZM30.1 28.6833L28.2 28.5166L26.8834 26.2333L29.3167 18.9999L31.6334 18.2166L33.3 19.4333C33.3167 19.6166 33.3334 19.7999 33.3334 19.9999C33.3334 23.3166 32.1167 26.3499 30.1 28.6833Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.78345,
    y1: 7.25,
    x2: 18.9015,
    y2: 15.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 6.66675,
    y1: 18.2,
    x2: 15.9087,
    y2: 22.1487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 21.6667,
    y1: 7.25,
    x2: 31.7848,
    y2: 15.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 13.9501,
    y1: 14.0667,
    x2: 26.8395,
    y2: 23.9728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14.6835,
    y1: 28.3333,
    x2: 20.3474,
    y2: 36.6981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 26.9,
    y1: 18.2,
    x2: 36.1255,
    y2: 22.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 3.33337,
    y1: 3.33325,
    x2: 41.4385,
    y2: 29.7952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsSoccer);
export default __webpack_public_path__ + "static/media/sports_soccer.591c801853cd7566bcf24399a1fb85e7.svg";
export { ForwardRef as ReactComponent };